import { render, staticRenderFns } from "./profile-update-component.vue?vue&type=template&id=0dad387b&scoped=true"
import script from "./profile-update-component.vue?vue&type=script&lang=js"
export * from "./profile-update-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dad387b",
  null
  
)

export default component.exports